module.exports = __webpack_public_path__ + "img/home-ad-box.68a5ac77.png";